import React from "react";
import { Offcanvas } from "react-bootstrap";
import moment from "moment";
import "../../../Assets/Styles/component.css";
import { commonService } from "../../../utils/commonService";

const CancellationExposureDetailModal = ({
  showDetail,
  setShowDetail,
  detailData,
}) => {
  let risked_revenue = (detailData || []).reduce(
    (acc, curr) => acc + (parseFloat(curr?.risked_revenue) || 0),
    0,
  );
  let validCancellationRiskItems = (detailData || []).filter(
    (curr) => parseFloat(curr?.cancellation_risk || 0) !== 0,
  );
  let cancellation_risk_sum = validCancellationRiskItems.reduce(
    (acc, curr) => acc + (parseFloat(curr?.cancellation_risk) || 0),
    0,
  );
  let cancellation_risk =
    validCancellationRiskItems.length > 0
      ? cancellation_risk_sum / validCancellationRiskItems.length
      : 0;
  let ly_cancellations = (detailData || []).reduce(
    (acc, curr) => acc + (parseInt(curr?.ly_cancellations, 10) || 0),
    0,
  );

  return (
    <Offcanvas
      show={showDetail}
      onHide={() => setShowDetail(false)}
      placement="end"
      className="mb-detail-offcanvas"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>
          MORNING BRIEFING → CANCELLATION DETAIL
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="p-0">
        {/* <div className="mb-detail-header">
          <h3 className="mb-detail-title">
            Cancellation Exposure — {"Next 30 Days"}
          </h3>
        </div> */}
        <div className="ce-mb-stat-grid">
          <div className="mb-stat-card">
            <div className="mb-stat-value">
              {commonService?.formateAmount(risked_revenue)}
            </div>
            <div className="mb-stat-label">Total Rev At Risk</div>
          </div>
          <div className="mb-stat-card">
            <div className="mb-stat-value">
              {`${cancellation_risk.toFixed(1)}%`}
            </div>
            <div className="mb-stat-label">Avg Cancellation Risk</div>
          </div>
          <div className="mb-stat-card">
            <div className="mb-stat-value">
              {commonService?.formateRoom(ly_cancellations)}
            </div>
            <div className="mb-stat-label">Cancellations Last Year</div>
          </div>
        </div>
        <div className="mb-section">
          <table className="mb-detail-table">
            <thead>
              <tr>
                <th className="mb-detail-th mb-detail-th-left">DATE</th>
                <th className="mb-detail-th mb-detail-th-center">Risk</th>
                <th className="mb-detail-th mb-detail-th-center">
                  Canc Risk OTB
                </th>
                <th className="mb-detail-th mb-detail-th-center">Bookings</th>
                <th className="mb-detail-th mb-detail-th-right">Rev At Risk</th>
              </tr>
            </thead>
            <tbody>
              {detailData && detailData.length > 0 ? (
                detailData.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td className="mb-detail-td mb-detail-td-left">
                        {commonService?.getDateInFormat(item?.stay_date)}
                      </td>
                      <td className="mb-detail-td mb-detail-td-center">
                        {item?.cancellation_risk
                          ? item?.cancellation_risk + "%"
                          : "0%"}
                      </td>
                      <td className="mb-detail-td mb-detail-td-center">
                        {commonService?.formateRoom(item?.cancellation_delta)}
                      </td>
                      <td className="mb-detail-td mb-detail-td-center">
                        {commonService?.formateRoom(item?.total_bookings)}
                      </td>
                      <td className="mb-detail-td mb-detail-td-right">
                        {commonService?.formateAmount(item?.risked_revenue)}
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="mb-detail-no-data">
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CancellationExposureDetailModal;
